import { NetworkStatus } from '@cbridge-utils/network';
import { IStreamStore } from './stream.interface';

export const streamInitialState: IStreamStore = {
  data: {},
  listNetworkStatus: NetworkStatus.None,
};
